import { useState, useEffect, useMemo, useCallback } from 'react'
import { activationControls, useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import { KeyboardControl } from '../../molecules/KeyboardControls'

interface SkipLinkProps {
  targetId: string
  [rest: string]: any
}

export default function SkipLink ({ targetId, ...rest }: SkipLinkProps) {
  const [wasFocused, setWasFocused] = useState<boolean>(false)

  const id = useMemo(() => `skip-link-${targetId}`, [targetId])

  const keyboardControls = useKeyboardControls()

  // Only focus the skip link the first time it is rendered
  useEffect(() => {
    if (!wasFocused) {
      keyboardControls.setFocusedElement(id)
      setWasFocused(true)
    }
  }, [wasFocused, id, keyboardControls])

  const handleClick = useCallback(() => {
    keyboardControls.setFocusedElement(targetId)
  }, [keyboardControls, targetId])

  const handleKeyDown = useCallback((event: any) => {
    const keyPressed = event.key
    if (!activationControls.includes(keyPressed)) {
      return
    }
    keyboardControls.setFocusedElement(targetId)
  }, [keyboardControls, targetId])

  return (
    <KeyboardControl>
      <a
        id={id}
        role='link'
        tabIndex={-1}
        data-testid={id}
        className='sr-only focusable'
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        {...rest}
      >
        Skip to main content
      </a>
    </KeyboardControl>
  )
}
